import { Image, Pressable } from 'native-base'

import { BoxWithShadow } from './atoms'

import { useCallback, useMemo, useNavigation, useDeviceInfo } from '~hooks'
import { Images_Demo } from '~images'
import { NftType } from '~types/nfts'

type NFTCircleType = {
  nft: NftType
  numOfColumns?: number
}

const PADDING = 16
const SHADOW_HEIGHT = 12
const DEFAULT_TOKEN_WIDTH = 200
export const NFTCircle = ({ nft, numOfColumns }: NFTCircleType) => {
  const { navigate } = useNavigation<WalletScreenProps['navigation']>()
  const { deviceSpecificWidth } = useDeviceInfo()

  const NFT_DIMENSION = useMemo(
    () =>
      !numOfColumns
        ? DEFAULT_TOKEN_WIDTH
        : (deviceSpecificWidth - PADDING * numOfColumns) / numOfColumns,
    [deviceSpecificWidth, numOfColumns]
  )
  const PLACEHOLDER_DIMENSION = useMemo(() => NFT_DIMENSION - SHADOW_HEIGHT, [NFT_DIMENSION])

  const navigateToNftDetails = useCallback(
    () => (nft?.image ? navigate('NftDetails', { nftId: nft.id }) : undefined),
    [navigate, nft]
  )
  return (
    <BoxWithShadow
      height={PLACEHOLDER_DIMENSION}
      mb={4}
      rounded="full"
      shadowSize="l"
      width={PLACEHOLDER_DIMENSION}
    >
      <Pressable
        onPress={navigateToNftDetails}
        width={PLACEHOLDER_DIMENSION}
        height={PLACEHOLDER_DIMENSION}
        bg={nft?.image ? 'transparent' : '#EBECF1'}
        p={nft?.image ? 0 : 5}
        overflow="hidden"
        rounded="full"
      >
        <Image
          alt="NFT image"
          resizeMode="cover"
          flexShrink={1}
          source={nft?.image ? { uri: nft?.image } : Images_Demo.NFT_PLACEHOLDER}
          h="full"
          w="full"
        />
      </Pressable>
    </BoxWithShadow>
  )
}
